import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';

// 一般及第三方匯入
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';

import { ContactDialogModule } from '../contact-dialog/contact-dialog.module';
import { CookiesDialogModule } from '../cookies-dialog/cookies-dialog.module';

import { NavHeaderComponent } from './nav-header.component';

@NgModule({
	declarations: [NavHeaderComponent],
	imports: [
		RouterModule, 
		CollapseModule, 
		BsDropdownModule, 
		BrowserModule, 
		ContactDialogModule, 
		CookiesDialogModule,
		TranslateModule, 
		DropdownModule,
		FormsModule
	],
	exports: [NavHeaderComponent],
})
export class NavHeaderModule {}
